import { useMutation } from '@tanstack/react-query';
import { operations } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type CreateBankAccountRelinkTokenResponse =
  operations['createSupplierIntegrationRelinkToken']['responses'][201]['content']['application/json'];

const useCreateBankAccountRelinkToken = () => {
  return useMutation({
    mutationKey: ['createBankAccountRelinkToken'],
    mutationFn: (bankAccountUuid: string) => {
      return apiClient
        .post(`api/supplier-experience/bank-accounts/${bankAccountUuid}/relink-token`)
        .json<CreateBankAccountRelinkTokenResponse>();
    },
  });
};

export default useCreateBankAccountRelinkToken;
